export default function PerformanceBadge(props: { performanceLevel: string }) {
  const { performanceLevel } = props;
  const getBadgeData = (level: string) => {
    switch (level) {
      case "Strong":
        return { color: "bg-green-100 text-green-800", icon: "✓", label: "Strong" };
      case "Good":
        return { color: "bg-blue-100 text-blue-800", icon: "○", label: "Good" };
      case "Needs Work":
        return { color: "bg-orange-100 text-orange-800", icon: "↑", label: "Needs Work" };
      default:
        return { color: "bg-gray-100 text-gray-800", icon: "?", label: "Unknown" };
    }
  };

  const data = getBadgeData(performanceLevel);
  return (
    <div className={`inline-flex items-center gap-1.5 ${data.color} border rounded-full px-2 py-1 text-xs font-medium`}>
      <span className="font-bold">{data.icon}</span>
      <span>{data.label}</span>
    </div>
  );
}
